import { TolgeeProvider } from '@tolgee/react';
// i18n
import { i18n } from './locales/i18n';

// scroll bar
import 'simplebar/src/simplebar.css';

// lightbox
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';

// toast
import 'react-toastify/dist/ReactToastify.css';

import { LocalizationProvider } from '@mui/x-date-pickers';
// @mui
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// redux
import { QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/lib/integration/react';

// toast
import { ToastContainer } from 'react-toastify';

import { ApolloProvider } from '@apollo/client';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
// routes
//? using the Router exported from index create circular dependency
//? because some components uses routes contest from Router/index
//? later we should move the routes to another folder
import { Router } from './Router/Router';
import { persistor, store } from './redux/store';

// locales
import ThemeLocalization from './locales';
// theme
import ThemeProvider from './theme';

import { MotionLazyContainer } from './components/animate';
import ScrollToTop from './components/scroll-to-top';
import { ThemeSettings } from './components/settings/ThemeSettings';
import { ThemeSettingsProvider } from './components/settings/ThemeSettingsContext';

import { GoogleOAuthProvider } from '@react-oauth/google';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider } from './auth/JwtContext';
import { ReactQueryErrorHandler } from './components/ReactQueryErrorHandler';
import SnackbarProvider from './components/snackbar';
import { STRIPE_PUBLISHABLE_KEY } from './config-global';
import { ChatContextProvider } from './provider/ChatContext';
import { FileUploadContextProvider } from './provider/FileUploadContext';
import { client } from './requests/apolloClient';
import { Analytics } from './services/analytics';
import { queryClient } from './utils/react-query';

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

export default function App() {
  return (
    <GoogleOAuthProvider clientId="397593958126-86mavvd9m49ajpmcgjvdpgeq7nb9bj7b.apps.googleusercontent.com">
      <ApolloProvider client={client}>
        <AuthProvider>
          <HelmetProvider>
            <ReduxProvider store={store}>
              <PersistGate loading={null} persistor={persistor}>
                <QueryClientProvider client={queryClient}>
                  <ReactQueryDevtools
                    initialIsOpen={false}
                    position="bottom-right"
                  />
                  <TolgeeProvider tolgee={i18n}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <ThemeSettingsProvider>
                        <Elements stripe={stripePromise}>
                          <Analytics.Provider>
                            <FileUploadContextProvider>
                              <BrowserRouter>
                                <ScrollToTop />
                                <Analytics.PageViewListener />
                                <MotionLazyContainer>
                                  <ThemeProvider>
                                    <ThemeSettings>
                                      <ThemeLocalization>
                                        <SnackbarProvider>
                                          <ChatContextProvider>
                                            <Router />
                                            <ReactQueryErrorHandler />
                                            <ToastContainer />
                                          </ChatContextProvider>
                                        </SnackbarProvider>
                                      </ThemeLocalization>
                                    </ThemeSettings>
                                  </ThemeProvider>
                                </MotionLazyContainer>
                              </BrowserRouter>
                            </FileUploadContextProvider>
                          </Analytics.Provider>
                        </Elements>
                      </ThemeSettingsProvider>
                    </LocalizationProvider>
                  </TolgeeProvider>
                </QueryClientProvider>
              </PersistGate>
            </ReduxProvider>
          </HelmetProvider>
        </AuthProvider>
      </ApolloProvider>
    </GoogleOAuthProvider>
  );
}
